import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';

export type RoleId = 1 | 3;

function getRoleId(): RoleId | null {
  const raw = localStorage.getItem('roleId') ?? sessionStorage.getItem('roleId');
  if (!raw) return null;

  const n = Number(raw);
  if (n === 1 || n === 3) return n as RoleId;

  return null;
}

export function roleGuard(allowedRoleIds: RoleId[]): CanActivateFn {
  return (): boolean | UrlTree => {
    const router = inject(Router);

    const roleId = getRoleId();

    // ✅ اگر roleId نداریم، اجازه نده (این مهمه)
    if (roleId === null) {
      return router.parseUrl('/auth/login');
    }

    if (!allowedRoleIds.includes(roleId)) {
      return router.parseUrl('/notfound');
    }

    return true;
  };
}
